import VenoBox from 'venobox';

import 'venobox/dist/venobox.css'

export default function basicModal() {

    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const modal = new VenoBox({
        selector: '.js-modal-open'
    });
}